// removed by extract-text-webpack-plugin
module.exports = {"usersContainer":"Users__usersContainer__lPzqx","addUserLabel":"Users__addUserLabel__cr86G","inputBox":"Users__inputBox__3wxK4","addUserDes":"Users__addUserDes__2C6eU"};


//////////////////
// WEBPACK FOOTER
// ./src/views/project/projectComponents/users/Users.styl
// module id = 751
// module chunks = 0